export enum AccountDetailsFlowType {
  Login,
  InApp,
}
